import { forwardRef, useImperativeHandle, useState } from 'react'
import { Alert, Snackbar } from '@mui/material'
import Slide, { SlideProps } from '@mui/material/Slide'
import { ResponseMessage } from '../../../shared/model/models'

interface Props {}

const SlideTransition = (props: SlideProps) => {
  return <Slide {...props} direction="down" />
}

export type FsAlertRef = {
  openAlert: (message: ResponseMessage) => void
}

const FsAlert = forwardRef<FsAlertRef, Props>((_, ref) => {
  const [alert, setAlert] = useState({} as ResponseMessage | null)

  useImperativeHandle(ref, () => ({
    openAlert: (message) => {
      setAlert(message)
    },
  }))

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      sx={{ marginTop: -1.55, zIndex: 2000 }}
      autoHideDuration={5000}
      open={!!alert?.message}
      onClose={() => setAlert(null)}
      slots={{ transition: SlideTransition }}
    >
      <Alert
        onClose={() => setAlert(null)}
        severity={alert?.severity ?? undefined}
        sx={{ width: '100%' }}
      >
        {alert?.message}
      </Alert>
    </Snackbar>
  )
})

export default FsAlert
